fx.ns("desktop.frame", class FrameChoice extends shared.screens.BaseChoiceScreen 
{
    constructor()
    {
        super();

        this.showNext = false;
        this.showBack = fx.get("mode") == "creating" ;

        this.styleChoice = "square";

        this.containerHeight = 600; 
        this.valign = "bottom";

        this.title = fx.text("Choisissez la taille de votre cadre");

        this.mode = fx.get("mode") == "creating" ? "" : "popup";
    }

    get currentFormat()
    {
        return this.data.creation.formatid;
    }

    set currentFormat(val)
    {
        this.data.creation.formatid = val;
    }

    create() 
    {
        super.create();

        if (!this.data.creationOptions)
        {
            this.loading(true, fx.text("Chargement"));
            this.data.loadOptions();
        }
        else
            this.build();
    }


    onDataEvent(e)
    {
        if (e.type == "creation-options-loaded")
            this.build();
    }

    build() 
    {
        super.build();

        let options = this.data.creation.creationOptions.sort(function (a, b) { return a.price_base - b.price_base; });

        for (let i = 0; i < options.length; i++) 
        {
            let option = options[i];

            let choice = new shared.components.ProductChoice("square " + option.format.size, option, fx.assets.frame, fx.text(option.format.description), fx.text(option.format.name), fx.text("A partir de <strong>$ €</strong>", option.price_base * fx.get("lang").tax.toFixed(2)));
            choice.align = "bottom";
            
            if (this.currentFormat == option.id)
                choice.addClass("selected");

            this.addChoice(choice, {width: 250, height : 200, left : fx.browser.isDesktop ? 0 : "center"} );
        }

        this.loading(false);
    }

    onChoiceClicked(choice)
    {
        this.currentFormat = choice.formatid;
        
        if (fx.get("mode") == "creating") 
            this.data.event("next-step");
        else
            this.data.event("show-editor");
    }

    close()
    {
        this.data.event("show-editor");
    }

});